import React from "react";
import PropTypes from "prop-types";
import { Bell } from "lucide-react";

import "./NotificationsEmpty.scss";

/** Zero-state used by both the navbar dropdown and the full notifications page. */
const NotificationsEmpty = ({ title, description }) => (
  <div className="notifications-empty">
    <span className="notifications-empty__icon" aria-hidden="true">
      <Bell size={24} strokeWidth={1.75} />
    </span>
    <p className="notifications-empty__title">{title}</p>
    {description ? (
      <p className="notifications-empty__description">{description}</p>
    ) : null}
  </div>
);

NotificationsEmpty.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};

export default NotificationsEmpty;
